import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { LogOut, LayoutDashboard, Home } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_buildguard-preview/artifacts/3lbt7aob_nirmantra_ai_icon.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="backdrop-blur-xl bg-white/80 border-b border-slate-200/60 z-50 sticky top-0">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2.5" data-testid="navbar-logo">
          <img src={LOGO} alt="Nirmantra.ai" className="h-9 w-9 rounded-xl object-cover" />
          <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">Nirmantra<span className="text-[#0E9AC8]">.ai</span></span>
        </Link>
        {user && (
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" onClick={() => navigate("/")} data-testid="navbar-home-link"
              className="text-slate-600 hover:text-[#0E9AC8] rounded-xl hidden sm:inline-flex">
              <Home className="h-4 w-4 mr-1.5" strokeWidth={1.75} /> Home
            </Button>
            <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="navbar-dashboard-link"
              className="text-slate-600 hover:text-[#0E9AC8] rounded-xl hidden sm:inline-flex">
              <LayoutDashboard className="h-4 w-4 mr-1.5" strokeWidth={1.75} /> Dashboard
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-full pl-1 pr-3 py-1 hover:bg-slate-100 transition-colors">
                  {user.picture
                    ? <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-slate-200" />
                    : <div className="h-8 w-8 rounded-full bg-slate-900 text-white flex items-center justify-center text-xs font-semibold">{user.name?.[0] || "U"}</div>}
                  <span className="text-sm font-medium text-slate-700 hidden md:block">{user.name}</span>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="rounded-xl">
                <DropdownMenuItem onClick={() => navigate("/")} data-testid="menu-home" className="cursor-pointer">
                  <Home className="h-4 w-4 mr-2" strokeWidth={1.75} /> Home
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/dashboard")} data-testid="menu-dashboard" className="cursor-pointer">
                  <LayoutDashboard className="h-4 w-4 mr-2" strokeWidth={1.75} /> Dashboard
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={logout} data-testid="logout-button" className="cursor-pointer text-red-600 focus:text-red-600">
                  <LogOut className="h-4 w-4 mr-2" strokeWidth={1.75} /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    </header>
  );
}
